import { useQuery, QueryConfig } from "react-query";
import {getCurrentData, getGraphData} from "./api";
import {StationData} from "entities/station-data";
import {GraphDataType} from "entities/graph-data-type";

const CURRENT_DATA_KEY = "CURRENT_DATA";
const GRAPH_DATA_KEY = "GRAP_DATA";

export const useCurrentData = (queryConfig?: QueryConfig<StationData[]>) => useQuery(
    CURRENT_DATA_KEY,
    async () => (await getCurrentData()).data,
    queryConfig
);

export const useGraphData = (
    id: number,
    dataType: GraphDataType,
    from: number,
    to: number,
    enabled: boolean
) => useQuery(
    [ GRAPH_DATA_KEY, dataType, id, from, to ],
    async () => (await getGraphData(id, dataType, from, to)).data,
    { enabled }
);


